var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8E67C7940C71D5Ecbb55Cd49B16Ac20F0E89F912(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.5639 12.42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "TestCenter",
    d: "M0 3.69415L7.057 12.42C7.057 12.42 14.7517 0 14.5604 0C14.3691 0 6.46184 7.16538 6.46184 7.16538",
    fill: "url(#paint0_linear_2011_1660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_1660",
    x1: 3.39092e-8,
    y1: 12.42,
    x2: 10.5124,
    y2: -2.7986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E347F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C4A9F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8E67C7940C71D5Ecbb55Cd49B16Ac20F0E89F912);
export default __webpack_public_path__ + "static/media/8e67c7940c71d5ecbb55cd49b16ac20f0e89f912.45336849405a30bd36db1a5cededbce7.svg";
export { ForwardRef as ReactComponent };